(function () {
    'use strict';

    var serviceId = 'guardSvc';

    angular
        .module('app.security')
        .factory(serviceId, [
            '$translate',
            '$window',
            '$q',
            'userSvc',
            'appStatusSvc',
            '$state',
            '$rootScope',
            guardSvc
        ]);

    function guardSvc($translate, $window, $q, userSvc, appStatusSvc, $state, $rootScope) {
        var service = {
            guardRoute: guardRoute,
            guardRouteRenta: guardRouteRenta,
            guardRouteRole: guardRouteRole,
            authorized: authorized,
            hasRole: hasRole,
            checkCreditValue: checkCreditValue,
            checkCreditValueAsync: checkCreditValueAsync,
            checkCredit: checkCredit,
            hasPackage: hasPackage,
            hasRocket: hasRocket,
            hasDemo: hasDemo,
            monthlyPackage: monthlyPackage
        };

        function guardRouteRenta() {
            var storedLang = $window.lang || 'tr';
            var deferred = $q.defer();
            appStatusSvc.whenReady()['finally'](function () {
                var authResult = authorize();
                if (authResult.authorized) {
                    deferred.resolve(authResult.authorized);
                } else {
                    $state.go('signin', {
                        status: 'renta',
                        langcode: storedLang
                    });
                }
            });
            return deferred.promise;
        }

        function guardRoute(requiredRoles, blockMonthly) {
            var storedLang = $window.lang || 'tr';
            var deferred = $q.defer();
            appStatusSvc.whenReady()['finally'](function () {
                var authResult = authorize(requiredRoles);
                if (authResult.authorized && !blockMonthly) {
                    deferred.resolve(authResult.authorized);
                } else {
                    $state.go('signin', {
                        status: 'guard',
                        langcode: storedLang
                    });
                }
            });
            return deferred.promise;
        }

        function guardRouteRole(requiredRoles) {
            var storedLang = $window.lang || 'tr';
            var deferred = $q.defer();
            appStatusSvc.whenReady()['finally'](function () {
                var authResult = hasRole(requiredRoles);
                if (authResult) {
                    deferred.resolve(authResult);
                } else {
                    $state.go('signin', {
                        status: 'guard',
                        langcode: storedLang
                    });
                }
            });
            return deferred.promise;
        }

        function authorized(requiredRoles) {
            return authorize(requiredRoles).authorized;
        }
        function authorize(requiredRoles) {
            if (userSvc.info.SignedIn) {
                if (requiredRoles && requiredRoles.length > 0) {
                    if (userHasProduct(requiredRoles)) {
                        return {
                            authorized: true,
                            message: ''
                        };
                    } else {
                        return {
                            authorized: false,
                            message: $translate.instant('auth_roles')
                        };
                    }
                } else {
                    return {
                        authorized: true,
                        message: ''
                    };
                }
            } else {
                return {
                    authorized: false,
                    message: $translate.instant('auth_roles2')
                };
            }
        }
        // const roles = [
        // 	{ val: 0, name: 'Banlanmış' },
        // 	{ val: 5, name: 'Potansiyel Müşteri (Lead)' },
        // 	{ val: 10, name: 'Müşteri' },
        // 	{ val: 15, name: 'API' },
        // 	{ val: 20, name: 'Destek' },
        // 	{ val: 25, name: 'Satış' },
        // 	{ val: 30, name: 'Satış Takım Lideri' },
        // 	{ val: 40, name: 'Blog İçerik Üreticisi' },
        // 	{ val: 50, name: 'Admin' },
        // 	{ val: 55, name: 'Tenant' },
        // 	{ val: 60, name: 'Şirket İçi' },
        // 	{ val: 70, name: 'Satış Müdürü' },
        // 	{ val: 80, name: 'Tahsilat' }
        // ];
        function hasRole(pack) {
            if (pack.includes(userSvc.info.Role)) {
                return true;
            }
            return false;
        }

        function monthlyPackage() {
            var deferred = $q.defer();
            userSvc.getUserInfo().then(function (result) {
                var products = result.products.filter(function (m) {
                    //return m.productType === 20 && !m.isExpired && (m.subscriptionModel === 30 || m.code === 'basic-package');
                    return m.productType === 40 && !m.isExpired;
                })[0];
                deferred.resolve(products);
            }, function () {
                deferred.resolve(null);
            });
            return deferred.promise;
        }

        function hasDemo(page) {
            var deferred = $q.defer();
            userSvc.getFingerLimit(page).then(function () {
                if (userSvc.finger_info.prints[page])
                    deferred.resolve(!userSvc.finger_info.prints[page].limitReached);
                else
                    deferred.resolve(false);
            });
            return deferred.promise;
        }

        function hasRocket(rocket, force) {
            var deferred = $q.defer();
            userSvc.getUserInfo(force).then(function (result) {
                var products = result.products.map(function (m) {
                    return m.code;
                });
                if (!rocket) {
                    rocket = ['unlimited-comparable', 'listing-rocket', 'region-rocket'];
                }
                deferred.resolve(userHasProduct(rocket, products));
            }, function () {
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function hasPackage(pack, force) {
            var deferred = $q.defer();
            userSvc.getUserInfo(force).then(function (result) {
                var products = result.products.map(function (m) {
                    return m.code;
                });

                if (result.terminalProducts) {
                    var terminalProducts = result.terminalProducts.map(function (m) {
                        return m.code;
                    });
                    products = products.concat(terminalProducts);
                }

                if (!pack) {
                    pack = ['location-package', 'real-estate-package', 'platinum-package', 'eco-package', 'seller-lead-package','premium-package', 'premiumplus-package', 'personal-package', 'basic-package', 'terminal-package', 'pro-ee-package', 'flex-package', 'gold-package', 'terminal-flex-package', 'terminal-pro-package', 'premium-ee-package', 'terminal-premium-package'];
                }
                deferred.resolve(userHasProduct(pack, products));
            }, function () {
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function userHasProduct(requiredRoles, products) {
            products = products ? products : userSvc.info.Products.map(function (m) {
                return m.code;
            });

            if (userSvc.info.TerminalProducts) {
                var terminalProducts = userSvc.info.TerminalProducts.map(function (m) {
                    return m.code;
                });
                products = products.concat(terminalProducts);
            }

            var result = false;
            requiredRoles.forEach(function (product) {
                if (products.includes(product)) {
                    result = true;
                }
            });
            return result;
        }


        function checkCreditValue(creditId) {
            var selectedProducts = userSvc.info.Products.filter(function (product) {
                return product.code === creditId;
            });
            if (userSvc.info.TerminalProducts) {
                var selectedTerminalProducts = userSvc.info.TerminalProducts.filter(function (product) {
                    return product.code === creditId;
                });
                selectedProducts = selectedProducts.concat(selectedTerminalProducts);
            }
            var result = selectedProducts.reduce(function (a, b) {
                return a + b.count;
            }, 0);
            return result;
        }

        function checkCreditValueAsync(creditId, propertyType) {
            var deferred = $q.defer();
            userSvc.refreshProducts().then(function (result) {
                var selectedProducts = result.products.filter(function (product) {
                    return product.code === creditId && (!propertyType || product.type === 0 || (product.types || []).indexOf(propertyType) > -1);
                });

                if (result.terminalProducts) {
                    var selectedTerminalProducts = result.terminalProducts.filter(function (product) {
                        return product.code === creditId;
                    });
                    selectedProducts = selectedProducts.concat(selectedTerminalProducts);
                }

                var result = selectedProducts.reduce(function (a, b) {
                    return a + b.count;
                }, 0);
                deferred.resolve(result > 0 ? result : 0);
            }, function () {
                $rootScope.SignedIn = false;
                deferred.resolve(0);
            });
            return deferred.promise;
        }


        function checkCredit(creditId) {
            var deferred = $q.defer();
            userSvc.refreshProducts().then(function (result) {
                var products = result.products.map(function (m) {
                    return m.code;
                });

                if (result.terminalProducts) {
                    var terminalProducts = result.terminalProducts.map(function (m) {
                        return m.code;
                    });
                    products = products.concat(terminalProducts);
                }

                deferred.resolve(products.indexOf(creditId) > -1);
            }, function () {
                $rootScope.SignedIn = false;
                deferred.resolve(false);
            });
            return deferred.promise;
        }


        return service;
    }
})();
